import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const ManagersReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions("LastName", 10000),
    ...FormActionReducer.defaultRecordState()
  },
  action) => {

  if (action.scope === ScopeConstants.MANAGER) {
    if (action.type === "CHANGE_PAGE_SIZE") {
      return {
        ...state,
        searchOptions: { 
          ...state.searchOptions,
          pageSize: action.pageSize
        }
      }
    }
    return FormActionReducer.reduce(action, state)
  }
  
  return state
}